var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi } from '.';
import { concatWithSymbol } from '../utils/common';
import { isProduction } from '../config/constants';
/**
 * cms 的代理接口
 * @export
 * @description 相关介绍见：{@link https://www.tapd.cn/55958943/markdown_wikis/show/#1155958943001000717}
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function dataApi(target, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield proxyApi({ module: 'site', target, data, freeLogin: 1 })).ret;
    });
}
/**
 * 获取数据模块列表
 */
export function getDataModules(dataPoolId) {
    return dataApi('QDataModules', { dataPoolId });
}
/**
 * 获取数据模块详情
 */
export function getDataModule(options) {
    return dataApi('QDataModule', Object.assign({ includeDataHierarchies: true, recursive: options.includeDataHierarchies !== false }, options));
}
/**
 * 获取数据模块层级字段
 */
export function getDataHierarchyTemplate(dataModuleId) {
    return dataApi('QDataHierarchyTemplate', { dataModuleId });
}
/**
 * 获取数据模块层级列表
 * @template T 返回的数据结构
 * @param {string} dataModuleId
 * @param {((string|number)[])} customIds 层级的属性id
 * @param {string} searchKey 匹配`customIds`包含的值
 */
export function getDataHierarchies(dataModuleId, customIds, searchKey) {
    return dataApi('QDataHierarchies', { dataModuleId, customIds, searchKey });
}
/**
 * 获取模块层级
 */
export function getDataHierarchy(options) {
    return dataApi('QDataHierarchy', Object.assign({ includeDataHierarchies: true, recursive: options.includeDataHierarchies !== false }, options));
}
/**
 * 获取所有Template
 */
export function getDataTemplates(dataPoolId) {
    return dataApi('QDataTemplates', { dataPoolId });
}
/**
 * 获取Template详情
 */
export function getDataTemplate(dataTemplateId) {
    return dataApi('QDataTemplate', { dataTemplateId });
}
/** 默认的筛选状态 */
export const DefaultStatuses = isProduction ? ['Enable'] : ['Enable', 'Test'];
/**
 * 获取数据列表
 * @description 排序默认按createtime排序，desc为true时按反序排，false按顺序排
 * @param {string} searchKey 搜索值
 * @param {string[]} customIds 搜索字段id，搜索值存在时必传
 * @param {boolean} searchTags 搜索范围是否包含标签名称
 * @remarks
 * dataTemplateId必传；
 * dataModuleId/dataHierarchyId 只能传其中一个，不传则获取templateid表的所有数据；
 * 传入dataModuleId时，recursive需要传true，用于获取模块下所有数据；
 * 传入dataHierarchyId时，recursive为ture获取本层和所有子层数据，为false只获取当前层级数据
 * includeParentDataHierarchyIds为true时每条数据会加上最近的层级(与搜索范围有关)
 */
export function getDataRows(params) {
    return dataApi('QDataRows', Object.assign({ orderBy: 'createtime', statuses: DefaultStatuses, desc: true }, params));
}
/**
 * 全局搜索数据
 * @template T 返回的template detail数据结构
 * @template P 查询范围
 */
export function searchDataRowsInGlobal(params) {
    return dataApi('QGlobalSearchDataRows', Object.assign({ statuses: DefaultStatuses, desc: true }, params));
}
/**
 * 获取某一行数据
 */
export function getDataRow(params) {
    return dataApi('QDataRow', Object.assign({ statuses: DefaultStatuses }, params));
}
/**
 * 批量获取数据
 */
export function getDataRowByIds(params) {
    return dataApi('QDataRowsByIds', Object.assign({ statuses: DefaultStatuses }, params));
}
/**
 * 获取推荐数据
 */
export function getRecommendDataRows(params) {
    return dataApi('QRecommendDataRows', Object.assign({ statuses: DefaultStatuses }, params));
}
/**
 * 获取数据或层级的完整路径
 * @remarks dataRowId,dataHierarchyId至少一项不为空;
 * 传入dataRowId时最里层会有`dataRow`字段
 * @template T 模块属性
 * @param {{ dataRowId?: string, dataHierarchyId?: string, dataModuleId: string }} params
 */
export function getDataPaths(params) {
    return dataApi('QDataPaths', Object.assign({ statuses: DefaultStatuses }, params));
}
/**
 * 获取并拼接层级路径名称
 * @param {string} dataHierarchyId 层级id
 * @param {...string[]} concatNames 其他名称
 */
export function getPathNames(dataHierarchyId, ...concatNames) {
    return __awaiter(this, void 0, void 0, function* () {
        const [paths] = yield getDataPaths({ dataHierarchyId });
        if (!paths)
            return '';
        const res = [paths.name];
        let t = paths.dataHierarchy;
        while (t) {
            res.push(t.name);
            t = t === null || t === void 0 ? void 0 : t.dataHierarchy;
        }
        return concatWithSymbol(res.concat(concatNames));
    });
}
